export default class ClientModel {
    ClientId: number;
	TaxStatusId: number; 
	TaxStatus: string;
	ModeOfHoldingId: number;
	ModeOfHolding: string;
	ClientRatingsId: number;
	ClientRating: string;
	ReferedBy: string;
	TitleId: number;
	Title:string;
	ClientName: string; 
	FamilyHeadId: number;
	FamilyHeadName: string;
	GenderId: number;
	Gender: string;
	EmailId: string;
	MobileNumber: string;
	DateOfBirth: Date;
	DateOfAnniversary: Date
	PlaceOfBirth: string;
	CountryOfBirth: string;
	Occupation: string;
	PANNo: string;
	Nominee: string;
	Address: AddressModel[];
	ClientInvestment: ClientInvestmentDetail[];
	DPID: string;
	NPSAccountNumber: string;
	AnnualIncome: string;
	GrossAnnualIncome: string;
	NetWorth: string; 
	BankName: string; 
	BranchName: string; 
	AccountNumber: string; 
	IFSCCode: string; 
}

export class AddressModel {
	AddressId: number;
	AddressLine1: string;
	AddressLine2: string;
	AddressLine3: string;
	City: string;
	State: string;
	Country: string;
	PinNumber: string;
}

export class ClientInvestmentDetail {
	ClientInvestmentDetailId: number;
	ClientId: number;
	ClientCompanyTypeId: number;
	ClientCompanyTypeName: string;
	ClientCompanyId: number;
	ClientCompanyName: string;
}

export const TaxStatusOptions =  [
        { value: '1', label: 'Individual', name:'TaxStatus' },
        { value: '2', label: 'Sole Propritorship', name:'TaxStatus' },
        { value: '3', label: 'HUF', name:'TaxStatus' },
		{ value: '4', label: 'LLP', name:'TaxStatus' },
		{ value: '5', label: 'NRI - REPATRIABLE (NRO)', name:'TaxStatus' },
		{ value: '6', label: 'PRIVATE LIMITED COMPANY', name:'TaxStatus' },
];
  

export const GenderOptions = [
      { value: '1', label: 'Male' , name:'Gender'},
      { value: '2', label: 'Female' , name:'Gender'},
      { value: '3', label: 'Transgender' , name:'Gender'}
];

export const PersonTitleOptions = [
      { value: '1', label: 'Mr.' , name:'PersonTitle'},
      { value: '2', label: 'Mrs.' , name:'PersonTitle'},
      { value: '3', label: 'Ms.' , name:'PersonTitle'}
];

export const ModeOfHoldingOptions = [
	{ value: '1', label: 'Single' , name:'ModeOfHolding'},
	{ value: '2', label: 'Multiple' , name:'ModeOfHolding'}
];

export const ClientRatingsOptions = [
	{ value: '1', label: 'VIP' , name:'ClientRatings'},
	{ value: '2', label: 'Average' , name:'ClientRatings'},
	{ value: '3', label: 'Prefer' , name:'ClientRatings'},
];